// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-pages__SendEmail__rejectedMessage__i5CzP {\n  color: #c70000;\n  margin-top: 12px;\n}\n\n.auth-pages__SendEmail__resolvedMessage__1z1pB {\n  color: #14a352;\n  margin-top: 12px;\n}", ""]);
// Exports
exports.locals = {
	"rejectedMessage": "auth-pages__SendEmail__rejectedMessage__i5CzP",
	"resolvedMessage": "auth-pages__SendEmail__resolvedMessage__1z1pB"
};
module.exports = exports;
